import { render } from "./PageNavbar.vue?vue&type=template&id=3b01af34&scoped=true"
import script from "./PageNavbar.vue?vue&type=script&lang=js"
export * from "./PageNavbar.vue?vue&type=script&lang=js"

import "./PageNavbar.vue?vue&type=style&index=0&id=3b01af34&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b01af34"]])

export default __exports__